export const FETCH_SUB_MENU = "FETCH_SUB_MENU";
export const FETCH_SUB_MENU_SUCCESS = "FETCH_SUB_MENU_SUCCESS"
